import styled from "styled-components";

import { screen } from "../BreakPoints";
import { Typography } from "../Typography/Typography";

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  gap: 24px;

  ${screen.lg} {
    flex-direction: row;
  }
`;

export const SubContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  max-width: 400px;
  padding-left: 20px;
  padding-right: 20px;

  ${screen.lg} {
    align-items: flex-start;
  }
`;

export const StyledImg = styled.img`
  width: 280px;
  height: 280px;
`;

export const Title = styled(Typography)`
  margin-block-end: 8px;
  text-align: center;

  ${screen.lg} {
    text-align: start;
  }
`;

export const Description = styled(Typography)`
  text-align: center;

  ${screen.lg} {
    text-align: start;
  }
`;

export const FooterContainer = styled.div`
  margin-block-start: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;

  ${screen.lg} {
    flex-direction: row;
  }
`;
